import { cn } from '../lib/cn.ts'

type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'disabled'

const dotClasses: Record<BadgeVariant, string> = {
  success: 'bg-success',
  warning: 'bg-warning',
  error: 'bg-error',
  info: 'bg-info',
  disabled: 'bg-gray-400'
}

export function Badge ({ variant, className, children }: {
  variant?: BadgeVariant
  className?: string
  children: React.ReactNode
}): JSX.Element {
  return (
    <div
      className={cn('text-xs font-bold inline-flex gap-2 items-center border rounded-sm px-2 py-0.5 bg-white whitespace-nowrap', {
        'border-brand-primary-light': variant !== 'disabled',
        'border-gray-400': variant === 'disabled'
      }, className)}
    >
      {variant != null && <span className={cn('size-2.5 rounded-full', dotClasses[variant])} />}
      {children}
    </div>
  )
}
